import StyledButton from "../../buttons/StyledButton";
import BaseModal from "../BaseModal/BaseModal";
import warningIcon from "../../../../assets/warning-icon.svg";
import styles from "./WarningModal.module.css";
import { ReactNode } from "react";

const strings = {
  ok: "OK",
};

type Props = {
  modalLabel: string;
  body: ReactNode;
  closeText?: string;
  isOpen: boolean;
  onRequestClose: () => void;
  confirmText?: string;
  onConfirm?: () => void;
  isCancelLoading?: boolean;
  isConfirmLoading?: boolean;
};

export default function WarningModal({
  isOpen,
  isCancelLoading = false,
  isConfirmLoading = false,
  onRequestClose,
  modalLabel,
  body,
  closeText = strings.ok,
  confirmText,
  onConfirm,
}: Props) {
  return (
    <BaseModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      label={modalLabel}
      className={styles.container}
    >
      <img src={warningIcon} alt="" />
      <div className={styles.body}>{body}</div>
      <div className={styles.footer}>
        <StyledButton
          className={styles.button}
          onClick={onRequestClose}
          disabled={isConfirmLoading}
          isLoading={isCancelLoading}
        >
          {closeText}
        </StyledButton>
        {confirmText && onConfirm && (
          <StyledButton
            className={styles.button}
            variant="danger"
            onClick={onConfirm}
            disabled={isCancelLoading}
            isLoading={isConfirmLoading}
          >
            {confirmText}
          </StyledButton>
        )}
      </div>
    </BaseModal>
  );
}
